import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const TypemanualsView = lazy(() => import('../../container/crud/typemanuals/Index'));
const TypemanualsAdd = lazy(() => import('../../container/crud/typemanuals/Add'));


const PagesRoute = () => {
  const { path } = useRouteMatch();
  //<Route path={`${path}/dataTable`} component={DataTable} />
  return (
    <Switch>
      <Route path={`${path}/view`} component={TypemanualsView} />
      <Route path={`${path}/add`} component={TypemanualsAdd} />
      <Route exact path={`${path}/edit/:id`} component={TypemanualsAdd} />
    </Switch>
  );
};

export default PagesRoute;
